module.exports = __webpack_public_path__ + "static/media/Introduction1 Excerpt Translated by J_Lee_77777.7856ace6.md";